import type { ExperimentVariantValue } from "@/hooks/useFeatureFlags";
import type { Content } from "@prismicio/client";

/**
 * Gets the title variant based on the experiment variant
 * If no variants exist or no experiment is running, returns the default title
 */
export function getTitleVariant(
  page: Content.PremiumGameDetailsPageDocument,
  experimentVariant?: ExperimentVariantValue,
) {
  const variants = page.data.content_variants;

  // If no variants exist or no variant flag, return default title
  if (!variants?.length || !experimentVariant) return page.data.title;

  // Map variant to index (VariantA -> 0, VariantB -> 1)
  const variantIndex = experimentVariant === "VariantA" ? 0 : 1;

  // Return variant title if it exists, otherwise default title
  return variants[variantIndex]?.title ?? page.data.title;
}

/**
 * Gets the description variant based on the experiment variant
 * If no variants exist or no experiment is running, returns the default description
 */
export function getDescriptionVariant(
  page: Content.PremiumGameDetailsPageDocument,
  experimentVariant?: ExperimentVariantValue,
) {
  const variants = page.data.content_variants;

  // If no variants exist or no variant flag, return default description
  if (!variants?.length || !experimentVariant) return page.data.description;

  // Map variant to index (VariantA -> 0, VariantB -> 1)
  const variantIndex = experimentVariant === "VariantA" ? 0 : 1;

  // Return variant description if it exists, otherwise default description
  return variants[variantIndex]?.description ?? page.data.description;
}
